import { Link } from 'react-router-dom'

// Slim mobile brand bar. Navigation lives in the bottom tab bar (MobileNav);
// this bar is identity only.
const MobileHeader = () => {
    return (
        <div className="lg:hidden flex items-center gap-2.5 px-4 py-2.5 bg-bg-darkest border-b border-border-light sticky top-0 z-30">
            <Link to="/shelter" className="flex items-center gap-2.5 no-underline">
                <img src="/logo-mark.png" alt="Commonfolk Downfall" className="h-7 w-7 object-contain" />
                <div className="flex flex-col leading-none">
                    <span className="text-sm font-bold tracking-tight text-white">Commonfolk</span>
                    <span className="text-[9px] uppercase tracking-wider text-text-muted">Downfall</span>
                </div>
            </Link>
        </div>
    )
}

export default MobileHeader
